import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { DashboardContextProvider, useDashboardContext } from './components/DashboardContext';
import VendorDashboard from './indexAmazonVendor';
import SellerDashboard from './indexAmazonSeller';
import WalmartDashboard from './indexWalmart';
import DspDashboard from '../Dsp/OfaDailyPerformance/index';
import SystemDashboard from './indexSystem';
import NoAccessDashboard from './indexNoAccess';
import SubscriptionDashboard from '../Subscription/DashboardPage';
import FreemiumDashboard from '../Freemium/walmartOnePage';
import SellerProfitReport from '../Profits/index';
import { isAdRev } from '../../../shared/components/domainSupport';
import useClientMenuData from '../../Layout/sidebar/useClientMenuData';

function AccountDashboard() {
  const selectedSeller = useSelector(store => store.sellerSelect);
  const { state, actions } = useDashboardContext();
  const { isVendor } = state;
  const { setAccount } = actions;
  const clientMenuData = useClientMenuData(selectedSeller);
  const sectionControl = clientMenuData?.sectionControl;

  useEffect(() => {
    if (selectedSeller && Object.keys(selectedSeller).length > 0 && selectedSeller.value > 0) {
      setAccount(selectedSeller);
    }
  }, [selectedSeller]);

  /* eslint-disable-next-line */
  let Dashboard = <></>;
  if (selectedSeller.value > 0) {
    if (isAdRev()) {
      Dashboard = SubscriptionDashboard;
    } else if (selectedSeller.parentAccountId === 514) {
      Dashboard = SellerProfitReport;
    } else if (selectedSeller.type === 0) {
      Dashboard = SystemDashboard;
    } else if (selectedSeller.type === 4) {
      Dashboard = FreemiumDashboard;
    } else if (sectionControl && sectionControl.amazon) {
      // Amazon dashboard - determine if Vendor or Seller
      Dashboard = isVendor ? VendorDashboard : SellerDashboard;
    } else if (sectionControl && sectionControl.dsp) {
      Dashboard = DspDashboard;
    } else if (sectionControl && sectionControl.walmart) {
      Dashboard = WalmartDashboard;
    } else if (isVendor) {
      Dashboard = VendorDashboard;
    } else if (!isVendor) {
      Dashboard = SellerDashboard;
    }
  } else {
    Dashboard = NoAccessDashboard;
  }

  return (
    <Dashboard />
  );
}

export default function AccountDashboardWithContext() {
  return (
    <DashboardContextProvider>
      <AccountDashboard />
    </DashboardContextProvider>
  );
}
